export default {"src":"/_next/static/media/usIcon.a67931b1.svg","height":11,"width":10,"blurWidth":0,"blurHeight":0};